const route = (...routes) => {
    return (params = {}) => {
        const pathname = routes.reduce((fullURL, route) => {
            let nextString = route(params);
            if (typeof nextString !== 'string')
                nextString = nextString.pathname;
            return fullURL + nextString;
        }, '');
        return {
            routeType: params.routeType || 'push',
            query: params.query || {},
            pathname,
        };
    };
};

export const routeToHome = route(() => '/');

export const routeGoBack = () => ({ routeType: 'goBack' });

export const routeToTerm = route(({ termId }) => `term/${termId}`);

export const routeToSection = route(({ sectionId }) => `section/${sectionId}`);

export const routeToGlobalSearch = route(
    ({ queryText }) => `search/${queryText}`
);

export const routeToLocalSearch = route(
    routeToGlobalSearch,
    ({ context }) => `/${context}`
);

export const routeToSearch = (queryText, contentID) =>
    contentID
        ? routeToLocalSearch({ context: contentID, queryText })
        : routeToGlobalSearch({ queryText });

export const routeToManagedDataType = route(({ currentPath, dataType }) => {
    return `${currentPath}/manage/${dataType}`;
});

export const routeToContent = route(({ contentId }) => `content-${contentId}`);

export const routeToContentPage = route(
    routeToContent,
    ({ pagenum }) => `/address/${pagenum}`
);

export const routeToAllNotes = route(
    ({ contentId }) => `notes/content-${contentId}`
);

const namedRouteMap = {
    content_page: params => routeToContentPage(params),
    all_notes: params => routeToAllNotes(params),
};

export const routeToNamedRoute = (namedRoute, params) =>
    namedRouteMap[namedRoute](params);

export const routeToApplications = route(() => `applications`);



// WEBPACK FOOTER //
// ./src/actions/route.js